import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=1d884f5a&"
import script from "./AboutView.vue?vue&type=script&lang=ts&"
export * from "./AboutView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports